export function ResidentialShowcase() {
  return (
    <section id="residential" className="relative overflow-hidden">
      <div className="grid lg:grid-cols-12">
        <div className="lg:col-span-5 bg-[#FF6B35] py-24 px-12 flex items-center relative">
          <div className="absolute top-12 right-12 text-white/10 text-9xl font-serif">"</div>
          <div className="relative z-10">
            <div className="mb-4">
              <span className="text-white/90 text-sm font-semibold tracking-wider uppercase">Residential</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6 leading-tight">Transform Your Home</h2>
            <p className="text-white/95 text-base leading-relaxed mb-8">
              From backyard oasis to complete home renovations, we bring your vision to life with expert craftsmanship and attention to detail. Our residential remodeling services enhance your living space and increase property value.
            </p>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-white hover:text-[#FF6B35] transition-all whitespace-nowrap cursor-pointer">
              View Residential Projects
            </button>
          </div>
        </div>

        <div className="lg:col-span-7 relative h-[600px] lg:h-auto">
          <img 
            src="https://public.readdy.ai/ai/img_res/bac7f5f2e9481243aabffe7cb4844ad4.jpg"
            alt="Residential remodeling Las Vegas - backyard transformation"
            className="w-full h-full object-cover"
            title="RW Construction Residential Projects"
          />
          <div className="absolute bottom-8 left-8 bg-white rounded-2xl shadow-2xl p-6 max-w-xs">
            <div className="text-3xl font-bold text-[#2C2C2C] mb-1">1500+</div>
            <div className="text-gray-600 text-sm mb-3">Homes Transformed</div>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-[#FF6B35] text-lg"></i>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}